import { useQuery, UseQueryResult } from 'react-query'
import request from '../request'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'
import { useBuildSortingParams } from '../../lib/hooks/useBuildSortingParams'

export const useGetTradeDeskAccounts = ({
  pageIndex,
  pageSize,
  filters,
}: {
  pageIndex?: number | null
  pageSize?: number | null
  filters?: Record<string, any>
  sorting?: Array<Record<string, any>>
}): UseQueryResult<any> => {
  const queryParams = useBuildQueryParams(filters)
  return useQuery(['admin', 'tradedesk', 'accounts', queryParams], ({ signal }) =>
    request({
      url: `/admin/dsp/tradedesk/accounts`,
      method: 'GET',
      params: {
        pageIndex,
        pageSize,
        ...queryParams,
      },
      signal,
    }),
  )
}
